import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import Diversity3OutlinedIcon from '@mui/icons-material/Diversity3Outlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import BookOutlinedIcon from '@mui/icons-material/BookOutlined';
import { useNavigate } from "react-router-dom";
import { AppBar, Box, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import InactivityMeter from './inactivitymeter';
import { blackcolor, pcolor, rcolor, registrationHeader, whitecolor } from '../../style2';
import LoginIcon from '@mui/icons-material/Login';
import { getApiUrl } from '../../services/api_service';
import LogoutIcon from '@mui/icons-material/Logout';

export default function NDReferralHeader(props) {
  const navigate = useNavigate();
  const [redirect, setRedirect] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [isLoggedIn, setIsLoggedIn] = useState(null);
  const [userType, setUserType] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
      setUserType(parsedAuthTokens?.userType);
    }
    if (!token) {
      setIsLoggedIn(false);
      return;
    }
    fetch(getApiUrl() + "/ReferrerAccount/istokenvalid", {
      method: "get",
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },

    }).then(resp => {
      if (resp.status === 200) {
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
    }).catch(err => {
      console.log(err);
    });
  }, [])



  return <>
    <AppBar style={{ position: "static", background: whitecolor, boxshadow: "none", marginBottom: "30px" }}>
      <Box style={{ height: "90px", display: "flex", justifyContent: "bottom", alignItems: 'center' }}>

        <Box sx={{ flexGrow: 1 }}>
          {(userType == 1 || !isLoggedIn) && <IconButton onClick={() => {
            if (window.location.pathname !== "/") {
              navigate("/");
            }
          }} style={{ marginRight: "20px", marginLeft: "20px" }}><HomeOutlinedIcon style={{ fontSize: "2.9rem", color: pcolor }} /></IconButton>}
          {isLoggedIn === true ? <IconButton onClick={() => {
            if (window.location.pathname !== `/patients/${props.orgCode}`) {
              navigate(`/patients/${props.orgCode}`);
            }
          }} style={{ marginRight: "20px", marginLeft: "20px" }}><Diversity3OutlinedIcon style={{ fontSize: "2.9rem", fontWeight: "lighter", color: pcolor }} /></IconButton> : null}
        </Box>
        <Box component="img" sx={{ height: "70px", width: "auto" }} src={props.logo ? props.logo : '../logo.jpg'} alt='Referral App logo'></Box>
        <Box sx={{ flexGrow: 1, textAlign: "right" }}>
          {/* Show Returning User? Signin if not logged in and not on login/register page */}
          {(isLoggedIn === false && typeof window !== 'undefined' &&
            !window.location.pathname.toLowerCase().includes('/login')) && (
              <Typography component="span" sx={{ color: blackcolor, fontSize: '1.1rem', verticalAlign: 'middle', ml: 1 }}>
                Returning User?{' '}
                <IconButton sx={{ mr: 1, ml: 1 }}
                  onClick={() => {
                    if (props.orgCode) {
                      if (window.location.pathname !== `/login/${props.orgCode}`) {
                        navigate(`/login/${props.orgCode}`);
                      }
                    } else {
                      if (window.location.pathname !== "/") {
                        navigate(`/`);
                      }
                    }
                  }}
                >
                  <LoginIcon sx={{ fontSize: "2.9rem", color: rcolor }} />
                </IconButton>
              </Typography>
            )}
          {isLoggedIn === true ? <>
            {/* <IconButton onClick={handleClick}
              id='profile-button'
              aria-controls={open ? 'profile-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              sx={{ mr: 1, ml: 1 }}>
              <AccountCircleOutlinedIcon sx={{ fontSize: "2.9rem", color: rcolor }} /></IconButton>
            <Menu
              id="profile-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              transformOrigin={{ vertical: "top", horizontal: "center", }} sx={{ top: 1 }}
              MenuListProps={{
                'aria-labelledby': 'profile-button',
              }}
            >
              <MenuItem onClick={() => { if (window.location.pathname !== `/updateaccount/${props.orgCode}`) { navigate(`/updateaccount/${props.orgCode}`); } handleClose(); }}>My Profile</MenuItem>
              <MenuItem onClick={() => { localStorage.clear(); if (window.location.pathname !== `/login/${props.orgCode}`) { navigate(`/login/${props.orgCode}`); } }}>Logout</MenuItem>
            </Menu> */}
            <IconButton onClick={() => { if (window.location.pathname !== `/updateaccount/${props.orgCode}`) { navigate(`/updateaccount/${props.orgCode}`); } }} sx={{ mr: 1, ml: 1 }}>
              <AccountCircleOutlinedIcon sx={{ fontSize: "2.9rem", color: rcolor }} />
            </IconButton>
            <IconButton onClick={() => { if (window.location.pathname !== `/resources/${props.orgCode}`) { navigate(`/resources/${props.orgCode}`); } }} sx={{ mr: 1, ml: 1 }}>
              <BookOutlinedIcon sx={{ fontSize: "2.9rem", fontWeight: "lighter", color: rcolor }} />
            </IconButton>
            <IconButton onClick={() => { localStorage.clear(); if (window.location.pathname !== `/login/${props.orgCode}`) { navigate(`/login/${props.orgCode}`); } }} sx={{ mr: 1, ml: 1 }}>
              <LogoutIcon sx={{ fontSize: "2.9rem", fontWeight: "lighter", color: rcolor }} />
            </IconButton>
          </> : null}
        </Box>
      </Box>
    </AppBar>
    {isLoggedIn ? <InactivityMeter loginurl={`/login/${props.orgCode}`} /> : null}
  </>;
}